import { giphyDarkGrey, giphyGreen } from '@giphy/colors'
import Checkbox from 'ui/src/components/controls/checkbox'

type Props = {
    isFreelance: boolean
    onChange: (isFreelance: boolean) => void
}

function Freelance({ isFreelance, onChange }: Props) {
    return (
        <div className="shrink-0">
            <div className="flex gap-2">
                <Checkbox
                    defaultChecked={isFreelance}
                    color={giphyDarkGrey}
                    iconColor={giphyGreen}
                    onChange={onChange}
                ></Checkbox>
                <span className="text-giphyWhite shrink-0 font-bold">Available for Work</span>
            </div>
        </div>
    )
}

export default Freelance
